<div class="grid" *ngIf="cargandoInformacion">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!cargandoInformacion">
  <div class="grid">
    <!-- AQUI EMPIEZA FORMULARIO CLONADO PARA MOSTRAR EN LA COMPARACIONES
          DE CONDICIONES -->
    <div [ngClass]="{
        'col-12 md:col-12 lg:col-12': !comparacion,
        'col-6 md:col-6 lg:col-6 separacion-condiciones': comparacion
      }" *ngIf="comparacion">
      <div class="col-12 md:col-12 lg:col-12">
        <p class="sub-titulo">
          {{
            "PAGADURIACONDICIONES.LBL_CONFIGURACIONCONDICIONESACTIVA"
              | translate
          }}
        </p>
      </div>
      <div *ngIf="pagaduriaCondicionComparar" class="grid form-group">
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }" *ngIf="detalle">
          <div class="div-form">
            <label>{{ "PAGADURIACONDICIONES.LBL_VERSION" | translate }}</label>
            <label class="falso-combo-texto" *ngIf="detalle">{{
              pagaduriaCondicionComparar.version
            }}</label>
          </div>
        </div>
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }">
          <div class="div-form">
            <label>*
              {{ "PAGADURIACONDICIONES.LBL_INICIOVIGENCIA" | translate }}</label>
            <label class="falso-combo-texto" *ngIf="detalle">{{
              pagaduriaCondicionComparar.fechaInicioVigencia
                | date: "dd-MM-yyyy"
            }}</label>
          </div>
        </div>
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }">
          <div class="div-form" style="margin-top: 20px">
            <p-checkbox binary="true" label="{{
                'PAGADURIACONDICIONES.LBL_APRUEBALIBRANZA' | translate
              }}" id="indicadorApruebaLibranza" [(ngModel)]="pagaduriaCondicionComparar.indicadorApruebaLibranza"
              [disableControl]="detalle"></p-checkbox>
          </div>
        </div>
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }">
          <div class="div-form">
            <label>* {{ "PAGADURIACONDICIONES.LBL_DIADEPAGO" | translate }}</label>
            <label class="falso-combo-texto" *ngIf="detalle">{{
              f.diaPago.value
            }}</label>
          </div>
        </div>
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }">
          <div class="div-form">
            <label>* {{ "PAGADURIACONDICIONES.LBL_DIADECORTE" | translate }}</label>
            <label class="falso-combo-texto" *ngIf="detalle">{{
              pagaduriaCondicionComparar.diaCorte
            }}</label>
          </div>
        </div>
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }">
          <div class="div-form">
            <label>*
              {{
                "PAGADURIACONDICIONES.LBL_DESFASEANTESCORTE" | translate
              }}</label>
            <label class="falso-combo-texto" *ngIf="detalle">{{
              pagaduriaCondicionComparar.desfaseAntes
            }}</label>
          </div>
        </div>
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }">
          <div class="div-form">
            <label>*
              {{
                "PAGADURIACONDICIONES.LBL_DESFASEDESPUESCORTE" | translate
              }}</label>
            <label class="falso-combo-texto"
              *ngIf="detalle && pagaduriaCondicion">{{ pagaduriaCondicionComparar.desfaseDespues }}</label>
          </div>
        </div>
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }">
          <div class="div-form">
            <label>* {{ "PAGADURIACONDICIONES.LBL_METODOFIRMA" | translate }}</label>
            <label class="falso-combo-texto"
              *ngIf="detalle && pagaduriaCondicion">{{ pagaduriaCondicionComparar.firma }}</label>
          </div>
        </div>
        <div [ngClass]="{
            'col-12 md:col-3 lg:col-3': !comparacion,
            'col-12 md:col-4 lg:col-4': comparacion
          }">
          <div class="div-form">
            <label>{{
              "PAGADURIACONDICIONES.LBL_METODOCUPO" | translate
            }}</label>
            <label class="falso-combo-texto" *ngIf="detalle">{{
              pagaduriaCondicionComparar.metodo
            }}</label>
          </div>
        </div>
        <div class="col-12">
          <div>
            <div class="col-12 md:col-12 lg:col-12">
              <p *ngIf="!comparacion" class="sub-titulo">
                {{
                  "PAGADURIACONDICIONES.LBL_FORMULADESPRENDIBLEPAGO" | translate
                }}
              </p>
              <p *ngIf="comparacion" class="sub-titulo">
                {{
                  "PAGADURIACONDICIONES.LBL_FORMULADESPRENDIBLEPAGOACTIVA"
                    | translate
                }}
              </p>
            </div>
            <div class="col-12 md:col-12 lg:col-12">
              <div class="parrafo-formula" *ngIf="metodo?.codigo === metodosCalculoCupo.METODO1">
                <p style="color: #009638">
                  (Salario - deducciones legales) x
                  <input autocomplete="false" [ngModel]="pagaduriaCondicionComparar.porcentajeParametro" name="porcentajeParametro" id="IdPorcentajeParametro"
                         [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999" [negativo]="true" [decimales]="2" *ngIf="!detalle" class="campo-porcentaje" (blur)="preCargarParametro()"/>
                  <label *ngIf="detalle">
                    {{pagaduriaCondicionComparar.porcentajeParametro}}
                  </label>%
                  > 1 SMMLV
                </p>
                <div class="p-messages-error p-corner-all" style="color: #e62a10"
                     *ngIf="submitted && f.porcentajeParametro.invalid">
                  {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                  {{ "LBL_REQUERIDO" | translate }}
                </div>
                <p>
                  Cupo = (Salario - deducciones legales) x
                  <input autocomplete="false" [(ngModel)]="pagaduriaCondicionComparar.porcentaje1" name="porcentaje1"
                    id="idPorcentaje1" [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999"
                    [decimales]="2" [negativo]="true" class="campo-porcentaje" *ngIf="!detalle" />
                  <label class="falso-combo" *ngIf="detalle">{{
                    pagaduriaCondicionComparar.porcentaje1
                  }}</label>%
                  - (deducciones netas ajustadas - deducciones legales)
                </p>
                <div class="p-messages-error p-corner-all" style="color: #e62a10"
                  *ngIf="submitted && f.porcentaje1.invalid">
                  {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                  {{ "LBL_REQUERIDO" | translate }}
                </div>

                <p style="color: #009638">
                  (Salario - deducciones legales) x
                  <label class="falso-combo">{{parametro ? parametro : pagaduriaCondicionComparar.porcentajeParametro}}</label>%
                  <= 1 SMMLV
                </p>
                <p>
                  Cupo = (Salario - deducciones netas ajustadas) - (SMMLV x
                  <input autocomplete="false" [(ngModel)]="pagaduriaCondicionComparar.porcentaje2" name="porcentaje2"
                      id="idPorcentaje2" [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999"
                      [decimales]="2" [negativo]="true" class="campo-porcentaje" *ngIf="!detalle" />
                    <label class="falso-combo" *ngIf="detalle">{{
                    pagaduriaCondicionComparar.porcentaje2
                  }}</label>%)
                </p>
                <div class="p-messages-error p-corner-all" style="color: #e62a10"
                  *ngIf="submitted && f.porcentaje2.invalid">
                  {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                  {{ "LBL_REQUERIDO" | translate }}
                </div>
              </div>
              <div class="parrafo-formula" *ngIf="metodo?.codigo === metodosCalculoCupo.METODO2">
                <p>
                  Cupo =  (Salario - deducciones netas ajustadas) - (SMMLV x
                  <input autocomplete="false" [(ngModel)]="pagaduriaCondicionComparar.porcentaje1" name="porcentaje1"
                    id="idPorcentaje1" [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999"
                    [decimales]="2" [negativo]="true" class="campo-porcentaje" *ngIf="!detalle" />
                  <label class="falso-combo" *ngIf="detalle">{{
                    pagaduriaCondicionComparar.porcentaje1
                  }}</label>%)
                </p>
                <div class="p-messages-error p-corner-all" style="color: #e62a10"
                  *ngIf="submitted && f.porcentaje1.invalid">
                  {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                  {{ "LBL_REQUERIDO" | translate }}
                </div>
              </div>

              <div class="parrafo-formula" *ngIf="metodo?.codigo === metodosCalculoCupo.METODO3">
                <p>
                  Cupo = (Salario x
                  <input autocomplete="false" [(ngModel)]="pagaduriaCondicionComparar.porcentaje1" name="porcentaje1"
                    id="idPorcentaje1" [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999"
                    [decimales]="2" [negativo]="true" class="campo-porcentaje" *ngIf="!detalle" />
                  <label class="falso-combo" *ngIf="detalle">{{
                    pagaduriaCondicionComparar.porcentaje1
                  }}</label>%
                  - deducciones netas ajustadas)
                </p>
                <div class="p-messages-error p-corner-all" style="color: #e62a10"
                  *ngIf="submitted && f.porcentaje1.invalid">
                  {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                  {{ "LBL_REQUERIDO" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!pagaduriaCondicionComparar" class="text-center sin-comparacion">
        {{ "PAGADURIACONDICIONES.LBL_NOHAYVALORESCOMPARAR" | translate }}
      </div>
    </div>
    <!-- AQUI TERMINA EL FORMULARIO CLONADO -->

    <!-- AQUI EMPIEZA EL FORMULARIO REACTIVO QUE SE USA PARA EL GUARDADO Y
          VISUALIZACION DE LAS CONDICIONES NORMALMENTE -->
    <div [ngClass]="{
        'col-12 md:col-12 lg:col-12': !comparacion,
        'col-6 md:col-6 lg:col-6': comparacion
      }">
      <form [formGroup]="formulario">
        <div *ngIf="comparacion" class="col-12 md:col-12 lg:col-12">
          <p class="sub-titulo">
            {{
              "PAGADURIACONDICIONES.LBL_CONFIGURACIONCONDICIONESACTUALIZADA"
                | translate
            }}
          </p>
        </div>
        <div class="grid form-group">
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }" *ngIf="detalle">
            <div class="div-form">
              <label>{{
                "PAGADURIACONDICIONES.LBL_VERSION" | translate
              }}</label>
              <input autocomplete="false" formControlName="version" name="version" id="idVersion" *ngIf="!detalle"
                pInputText />
              <label class="falso-combo-texto" *ngIf="detalle">{{
                f.version.value
              }}</label>
            </div>
          </div>
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }">
            <div class="div-form">
              <label>*
                {{
                  "PAGADURIACONDICIONES.LBL_INICIOVIGENCIA" | translate
                }}</label>
              <p-calendar id="idfechaInicioVigencia" [showButtonBar]="false" name="nomfechaInicioVigencia"
                [showIcon]="true" [showTime]="false" [monthNavigator]="true" [yearNavigator]="true"
                [minDate]="minFechaInicial" yearRange="{{ calPropiedades.rango }}" [locale]="calPropiedades.informacion"
                readonlyInput="true" formControlName="fechaInicioVigencia" *ngIf="!detalle" dataType="date"
                dateFormat="yy'-'mm'-'dd"></p-calendar>
              <div class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.fechaInicioVigencia.invalid">
                {{ "PAGADURIACONDICIONES.LBL_INICIOVIGENCIA" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <label class="falso-combo-texto" *ngIf="detalle">{{
                f.fechaInicioVigencia.value | date: "dd-MM-yyyy"
              }}</label>
            </div>
          </div>
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }">
            <div class="div-form" style="margin-top: 20px">
              <p-checkbox binary="true" label="{{
                  'PAGADURIACONDICIONES.LBL_APRUEBALIBRANZA' | translate
                }}" id="indicadorApruebaLibranza" formControlName="indicadorApruebaLibranza" [disableControl]="detalle">
              </p-checkbox>
            </div>
          </div>
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }">
            <div class="div-form">
              <label>* {{ "PAGADURIACONDICIONES.LBL_DIADEPAGO" | translate }}</label>
              <input autocomplete="false" formControlName="diaPago" name="diaPago" id="idDiaPago" numero-entero-reactive
                [maxlength]="2" capitalize-reactive [minimo]="1" [maximo]="30" pInputText *ngIf="!detalle" />
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diaPago.invalid">
                {{ "PAGADURIACONDICIONES.LBL_DIADEPAGO" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <label class="falso-combo-texto" *ngIf="detalle">{{
                f.diaPago.value
              }}</label>
            </div>
          </div>
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }">
            <div class="div-form">
              <label>*
                {{ "PAGADURIACONDICIONES.LBL_DIADECORTE" | translate }}</label>
              <input autocomplete="false" formControlName="diaCorte" name="diaCorte" id="idDiaCorte"
                numero-entero-reactive [maxlength]="2" capitalize-reactive [minimo]="1" [maximo]="30" pInputText
                *ngIf="!detalle" />
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diaCorte.invalid">
                {{ "PAGADURIACONDICIONES.LBL_DIADECORTE" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <label class="falso-combo-texto" *ngIf="detalle">{{
                f.diaCorte.value
              }}</label>
            </div>
          </div>
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }">
            <div class="div-form">
              <label>*
                {{
                  "PAGADURIACONDICIONES.LBL_DESFASEANTESCORTE" | translate
                }}</label>
              <p-dropdown disableTab  id="idDesfaseAntesCorte" name="nomDesfaseAntesCorte" [options]="lisTiempoDesfasesPagadurias"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                formControlName="idDesfaseAntesCorte" (onChange)="validarDesfaseAntesCorte()" *ngIf="!detalle">
              </p-dropdown>
              <div class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idDesfaseAntesCorte.invalid">
                {{ "PAGADURIACONDICIONES.LBL_DESFASEANTESCORTE" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <label class="falso-combo-texto" *ngIf="detalle && pagaduriaCondicion">{{
                  f.idDesfaseAntesCorte.value
                    ? pagaduriaCondicion.desfaseAntes
                    : ""
                }}</label>
            </div>
          </div>
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }">
            <div class="div-form">
              <label>*
                {{
                  "PAGADURIACONDICIONES.LBL_DESFASEDESPUESCORTE" | translate
                }}</label>
              <p-dropdown disableTab  id="idDesfaseDespuesCorte" name="nomDesfaseDespuesCorte"
                [options]="lisTiempoDesfasesPagadurias" placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                 formControlName="idDesfaseDespuesCorte" (onChange)="validarDesfaseDespuesCorte()"
                *ngIf="!detalle"></p-dropdown>
              <div class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idDesfaseDespuesCorte.invalid">
                {{ "PAGADURIACONDICIONES.LBL_DESFASEDESPUESCORTE" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <label class="falso-combo-texto" *ngIf="detalle && pagaduriaCondicion">{{
                  f.idDesfaseDespuesCorte.value
                    ? pagaduriaCondicion.desfaseDespues
                    : ""
                }}</label>
            </div>
          </div>
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }">
            <div class="div-form">
              <label>*
                {{ "PAGADURIACONDICIONES.LBL_METODOFIRMA" | translate }}</label>
              <p-dropdown disableTab  id="idMetodoFirma" name="nomMetodoFirma" [options]="lisTiposFirmasAutorizaciones"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"  formControlName="idMetodoFirma"
                *ngIf="!detalle"></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idMetodoFirma.invalid">
                {{ "PAGADURIACONDICIONES.LBL_METODOFIRMA" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <label class="falso-combo-texto" *ngIf="detalle && pagaduriaCondicion">{{
                  f.idMetodoFirma.value ? pagaduriaCondicion.firma : ""
                }}</label>
            </div>
          </div>
          <div [ngClass]="{
              'col-12 md:col-3 lg:col-3': !comparacion,
              'col-12 md:col-4 lg:col-4': comparacion
            }">
            <div class="div-form">
              <label>{{
                "PAGADURIACONDICIONES.LBL_METODOCUPO" | translate
              }}</label>
              <p-dropdown disableTab  id="idMetodoCalculoCupo" name="nomMetodoCalculoCupo" [options]="lisMetodosCalculoCupo"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                formControlName="idMetodoCalculoCupo" (onChange)="validarCamposRequeridos($event)" *ngIf="!detalle">
              </p-dropdown>
              <div class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idMetodoCalculoCupo.invalid">
                {{ "PAGADURIACONDICIONES.LBL_METODOCUPO" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <label class="falso-combo-texto" *ngIf="detalle && pagaduriaCondicion">{{
                  f.idMetodoCalculoCupo.value ? pagaduriaCondicion.metodo : ""
                }}</label>
            </div>
          </div>
          <div class="col-12">
            <div>
              <div class="col-12 md:col-12 lg:col-12">
                <p *ngIf="!comparacion" class="sub-titulo">
                  {{
                    "PAGADURIACONDICIONES.LBL_FORMULADESPRENDIBLEPAGO"
                      | translate
                  }}
                </p>
                <p *ngIf="comparacion" class="sub-titulo">
                  {{
                    "PAGADURIACONDICIONES.LBL_FORMULADESPRENDIBLEPAGOACTUALIZADA"
                      | translate
                  }}
                </p>
              </div>
              <div class="col-12 md:col-12 lg:col-12">
                <div class="parrafo-formula" *ngIf="metodo?.codigo === metodosCalculoCupo.METODO1">
                  <p style="color: #009638">
                    (Salario - deducciones legales) x
                    <input autocomplete="false" formControlName="porcentajeParametro" name="porcentajeParametro" id="IdPorcentajeParametro"
                    [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999" [negativo]="true" [decimales]="2" *ngIf="!detalle" class="campo-porcentaje" (blur)="preCargarParametro()"/>
                    <label *ngIf="detalle">
                      {{f.porcentajeParametro.value}}
                    </label>%
                     > 1 SMMLV
                  </p>
                  <div class="p-messages-error p-corner-all" style="color: #e62a10"
                       *ngIf="submitted && f.porcentajeParametro.invalid">
                    {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                  <p>
                    Cupo = (Salario - deducciones legales) x
                     <input autocomplete="false" formControlName="porcentaje1" name="porcentaje1" id="idPorcentaje1"
                      [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999" [decimales]="2"
                      [negativo]="true" class="campo-porcentaje" *ngIf="!detalle" />
                    <label class="falso-combo" *ngIf="detalle">{{
                      f.porcentaje1.value
                    }}</label>%
                     - (deducciones netas ajustadas - deducciones legales)
                  </p>
                  <div class="p-messages-error p-corner-all" style="color: #e62a10"
                    *ngIf="submitted && f.porcentaje1.invalid">
                    {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>

                  <p style="color: #009638">
                    (Salario - deducciones legales) x
                    <label class="falso-combo">{{parametro ? parametro : this.f.porcentajeParametro.value}}</label>%
                     <= 1 SMMLV
                  </p>
                  <p>
                    Cupo = (Salario - deducciones netas ajustadas) - (SMMLV x
                      <input autocomplete="false" formControlName="porcentaje2" name="porcentaje2" id="idPorcentaje2"
                        [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999" [decimales]="2"
                        [negativo]="true" class="campo-porcentaje" *ngIf="!detalle" />
                      <label class="falso-combo" *ngIf="detalle">{{
                      f.porcentaje2.value
                    }}</label>%)
                  </p>
                  <div class="p-messages-error p-corner-all" style="color: #e62a10"
                    *ngIf="submitted && f.porcentaje2.invalid">
                    {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
                <div class="parrafo-formula" *ngIf="metodo?.codigo === metodosCalculoCupo.METODO2">
                  <p>
                    Cupo = (Salario - deducciones netas ajustadas) - (SMMLV x
                    <input autocomplete="false" formControlName="porcentaje1" name="porcentaje1" id="idPorcentaje1"
                      [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999" [decimales]="2"
                      [negativo]="true" class="campo-porcentaje" *ngIf="!detalle" />
                    <label class="falso-combo" *ngIf="detalle">{{
                      f.porcentaje1.value
                    }}</label>%)
                  </p>
                  <div class="p-messages-error p-corner-all" style="color: #e62a10"
                    *ngIf="submitted && f.porcentaje1.invalid">
                    {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>

                <div class="parrafo-formula" *ngIf="metodo?.codigo === metodosCalculoCupo.METODO3">
                  <p>
                    Cupo = (Salario x
                    <input autocomplete="false" formControlName="porcentaje1" name="porcentaje1" id="idPorcentaje1"
                      [maxlength]="7" porcentaje-reactive pInputText [most]="-999" [maximo]="999" [decimales]="2"
                      [negativo]="true" class="campo-porcentaje" *ngIf="!detalle" />
                    <label class="falso-combo" *ngIf="detalle">{{
                      f.porcentaje1.value
                    }}</label>%
                     - deducciones netas ajustadas)
                  </p>
                  <div class="p-messages-error p-corner-all" style="color: #e62a10"
                    *ngIf="submitted && f.porcentaje1.invalid">
                    {{ "PAGADURIACONDICIONES.LBL_PORCENTAJE" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- AQUI FINALIZA EL FORMULARIO REACTIVO -->

    <div class="col-12">
      <div *ngIf="detalle">
        <div class="col-12 md:col-12 lg:col-12">
          <h6 *ngIf="!comparacion" class="sub-titulo">
            {{ "PAGADURIACONDICIONES.LBL_TRAZABILIDAD" | translate }}
          </h6>
          <h6 *ngIf="comparacion" class="sub-titulo">
            {{ "PAGADURIACONDICIONES.LBL_TRAZABILIDADACTUALIZADA" | translate }}
          </h6>
        </div>

        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="carTabla" #dt [value]="pagaduriasCondicionesHistoricos"
            selectionMode="single" dataKey="idPagaduriaCondicioneHistorico" [paginator]="true" [rows]="10"
            >
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{ row.version }}</td>
                <td>
                  {{ row.auditoriaFecha | date: "yyyy-MM-dd" }}
                </td>
                <td>{{ row.auditoriaFecha | date: "HH:mm:ss" }}</td>
                <td>{{ row.usuarioConfigura }}</td>
                <td>{{ row.usuarioAprueba }}</td>
                <td>{{ row.usuarioModifica }}</td>
                <td>{{ row.ipPublica }}</td>
                <td>{{ row.ipPrivada }}</td>
                <td>{{ row.estado }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ "MSG_NOHAYREGISTROS" | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="col-12 form-footer-buttons">
        <div class="form-group col-12">
          <div>
            <a (click)="cerrar(formulario.dirty)" class="cancelar">{{
              "BTN_CANCELAR" | translate
            }}</a>
            <button *ngIf="!detalle" icon="fa fa-floppy-o" label="{{ 'BTN_GUARDAR' | translate }}" type="submit"
              (click)="onSubmit()" pButton></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
